import axios from "../utils/axios";

export const getAllTeachers = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/teachers', { params });
    return data;
};

export const getTeachersForSelect = async () => {
    const { data } = await axios.get('/teachers/for-select');
    return data;
};

export const getTeacher = async (id) => {
    const { data } = await axios.get(`/teachers/${id}`);
    return data;
};

export const createTeacher = async (req) => {
    const { data } = await axios.post('/teachers', req, { headers: { Accept: 'application/json' } });
    return data;
};

export const updateTeacher = async (req, id) => {
    const { data } = await axios.put(`/teachers/${id}`, req, { headers: { Accept: 'application/json' } });
    return data;
};

export const deleteTeacher = async (id) => {
    const { data } = await axios.delete(`/teachers/${id}`, { headers: { Accept: 'application/json' } });
    return data;
};

export const deleteAllTeachers = async (req) => {
    const { data } = await axios.delete('/teachers/mass-destroy', { data: req, headers: { Accept: 'application/json' } });
    return data;
};

export const forceDeleteTeacher = async (id) => {
    const { data } = await axios.delete(`/teachers/${id}/force-delete`, { headers: { Accept: 'application/json' } });
    return data;
};

export const forceDeleteAllTeachers = async (ids) => {
    const { data } = await axios.delete('/teachers/mass-force-delete', { data: ids, headers: { Accept: 'application/json' } });
    return data;
};

export const restoreTeacher = async (id) => {
    const { data } = await axios.post(`/teachers/${id}/restore`, {}, { headers: { Accept: 'application/json' } });
    return data;
};

export const restoreAllTeachers = async (req) => {
    const { data } = await axios.post('/teachers/mass-restore', req, { headers: { Accept: 'application/json' } });
    return data;
};
